import React from 'react'
import PropTypes from 'prop-types'

const DisconnectIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="#007AFA" fillRule="evenodd">
      <rect width={width} height={height} fillOpacity=".15" rx="2" />
      <path
        fillRule="nonzero"
        d="M14.317 8.004C13.908 5.743 12.158 4.013 10 4.013c-.875 0-1.692.266-2.333.798l.875.998c.408-.332.933-.466 1.458-.466 1.75 0 3.208 1.664 3.208 3.66v.332h.875c.992 0 1.75.865 1.75 1.995 0 .732-.35 1.397-.933 1.73l.875.998C16.533 13.459 17 12.46 17 11.33c0-1.73-1.225-3.193-2.683-3.326zM4.75 4.878l1.633 1.796C4.517 6.807 3 8.537 3 10.665c0 2.195 1.575 3.992 3.5 3.992h6.825l1.167 1.33.758-.865L5.508 4.013l-.758.865zm2.742 3.126l4.666 5.322H6.5c-1.283 0-2.333-1.197-2.333-2.66 0-1.464 1.05-2.662 2.333-2.662h.992z"
      />
    </g>
  </svg>
)

DisconnectIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default DisconnectIcon
